import {assetExpirationEnabled} from '@netx/core-asset-expiration';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';
import {currentCartIsEmpty} from './currentCartIsEmpty';

export const canManageCurrentCartExpiration = (): boolean => {
	if (currentCartIsEmpty()) return false;
	if (!assetExpirationEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return currentUserHasAccess(PermissionName.EXPIRE);
};
